import {
  Drawer,
  Input,
  Paper,
  Select,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 50px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12);
`;

export const Header = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
`;

export const Title = styled.h2`
  color: ${COLORS.ACCORDION_TEXT_BLUE};
  font-size: 18px;
`;

export const StyledTableHead = styled(TableHead)`
  background-color: ${COLORS.TABLE_HEADER_BG};
  font-weight: 500;
`;

export const StyledTablePagination = styled(TablePagination)`
  display: block;
  color: ${COLORS.LIGHT_GREY};
`;

export const StyledTableRow = styled(TableRow)`
  cursor: pointer;
`;

export const StyledDrawer = styled(Drawer)`
  .MuiDrawer-paperAnchorRight {
    width: 400px;
  }
`;

export const StyledDrawerHeader = styled.div`
  height: 55px;
  background-color: white;
  font-weight: 700;
  font-size: 18px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledDrawerBody = styled.div`
  background-color: ${COLORS.DRAWER_BG_GRAY};
`;

export const StyledSelect = styled(Select)`
  &.MuiInput-underline.Mui-disabled:before {
    border-bottom-style: solid;
  }
  .MuiSelect-icon {
    color: black;
  }
  font-weight: 500;
`;

export const InputWrapper = styled.div`
  padding: 12px 24px;
`;

export const InputWithoutPaddingWrapper = styled.div`
  padding: 0px;
  margin-top: 20px;
`;
export const StyledInput = styled(Input)`
  &.MuiInput-underline.Mui-disabled:before {
    border-bottom-style: solid;
  }
  font-weight: 500;
`;

export const Element = styled(Paper)`
  display: inline-block;
  padding: 16px;
  text-transform: uppercase;
  font-weight: 500;
`;

export const ElementWrapper = styled.div`
  margin: 8px;
`;

export const ContainerWrapper = styled.div`
  padding: 0 24px;
`;

export const AssignedExpertTitle = styled.h3`
  text-transform: uppercase;
  color: rgba(0, 117, 201, 1);
  margin: 12px 24px;
`;
